import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useStorefront, useCartId, useClearCart, useCustomer } from '@kega/sps-core';

import { recoverFromStaleCart as recoverStaleCart, resetCartValidation, startCartValidation } from '../../lib/cart/cartRecovery';

const useCartRecovery = () => {
    const dispatch = useDispatch();
    const clearCart = useClearCart();
    const getCartId = useCartId();
    const { authenticated } = useCustomer();
    const { api: { cart } } = useStorefront();

    const recoveryDeps = { getCartId, authenticated, cart, dispatch, clearCart };

    const recoverFromStaleCart = useCallback(
        () => recoverStaleCart(recoveryDeps),
        [ authenticated, cart, clearCart, dispatch ]
    );

    useEffect(() => {
        resetCartValidation();
    }, [ authenticated ]);

    useEffect(() => {
        startCartValidation(recoveryDeps);
    }, [ authenticated, cart, clearCart, dispatch, getCartId ]);

    return { recoverFromStaleCart };
};

export default useCartRecovery;
